export enum Tabs {
  Trends,
  Viewers,
}
